var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", [
        _c("h4", [_vm._v("Configurador de plantillas para formularios")])
      ]),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center",
            "vs-w": "3"
          }
        },
        [
          _c("vs-input", {
            staticClass: "input-width",
            attrs: {
              label: "Nombre",
              placeholder: "Nombre",
              value: _vm.template.name
            },
            on: {
              input: function($event) {
                return _vm.changeTemplateProperty("name", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center",
            "vs-w": "3"
          }
        },
        [
          _c("vs-input", {
            staticClass: "input-width",
            attrs: {
              label: "Tipo",
              placeholder: "Tipo",
              value: _vm.template.type
            },
            on: {
              input: function($event) {
                return _vm.changeTemplateProperty("type", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center",
            "vs-w": "3"
          }
        },
        [
          _c("vs-input", {
            staticClass: "input-width",
            attrs: {
              label: "Descripción",
              placeholder: "Descripción",
              value: _vm.template.description
            },
            on: {
              input: function($event) {
                return _vm.changeTemplateProperty("description", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "flex-end",
            "vs-align": "center",
            "vs-w": "3"
          }
        },
        [
          _c(
            "vs-button",
            {
              attrs: { color: "success", type: "border", icon: "save" },
              on: {
                click: function($event) {
                  return _vm.saveTemplate()
                }
              }
            },
            [_vm._v(" Guardar ")]
          )
        ],
        1
      ),
      _c("vs-col", [
        _c(
          "div",
          { ref: "formio", staticClass: "m-top-20", attrs: { id: "formio" } },
          [
            _c("FormBuilder", {
              attrs: {
                form: _vm.schema,
                options: {
                  noDefaultSubmitButton: true
                }
              },
              on: {
                change: function(schema) {
                  return _vm.changeSchema(schema)
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Oops! Por favor verifica la información",
            centered: "",
            "hide-footer": ""
          },
          model: {
            value: _vm.validation,
            callback: function($$v) {
              _vm.validation = $$v
            },
            expression: "validation"
          }
        },
        [
          _c(
            "vs-list",
            _vm._l(_vm.textValidation, function(text, index) {
              return _c("vs-list-item", {
                key: index,
                attrs: { icon: "warning", title: text }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }